export const ADULT = 16;